import React from 'react'

// Admins column pill logic:
//   any pending → amber "N pending" (regardless of confirmed count)
//   else        → green "N active"
// The shared Pill primitive doesn't yet have a `warning` tone — adding one
// to the main design system is out of scope for this change, so the amber
// variant is rendered inline here and kept consistent via CSS variables.
const base = {
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: 12,
  padding: '2px 8px',
  fontSize: 11,
  fontWeight: 600,
}
const tones = {
  pending: { background: 'rgba(234, 179, 8, 0.15)', color: 'var(--info-text)' },
  active: { background: 'rgba(22, 163, 74, 0.15)', color: 'var(--success-text)' },
}

export function AdminsPill({ active = 0, pending = 0 }) {
  if (pending > 0) return <span style={{ ...base, ...tones.pending }}>{pending} pending</span>
  return <span style={{ ...base, ...tones.active }}>{active} active</span>
}
